import React from 'react';
import PropTypes from "prop-types";

import CountryFlag from "../../../components/CountryFlag";
import GeoService from "../../../services/geo";
import {createFilterOptions} from "@mui/material";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const StepGuest = props => {
    const {formik} = props;

    const filterOptions = createFilterOptions({
        matchFrom: 'start'
    });

    return (
        <>
            <Typography variant='h6' color='primary' fontWeight="normal" sx={{mb: 2}}>
                Anagrafica ospite
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <TextField label="Cognome"
                               fullWidth
                               name="surname"
                               value={formik.values.surname}
                               onChange={formik.handleChange}
                               error={formik.touched.surname && Boolean(formik.errors.surname)}
                               helperText={formik.touched.surname && formik.errors.surname}/>
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField label="Nome"
                               fullWidth
                               name="name"
                               value={formik.values.name}
                               onChange={formik.handleChange}
                               error={formik.touched.name && Boolean(formik.errors.name)}
                               helperText={formik.touched.name && formik.errors.name}/>
                </Grid>

                <Grid item xs={12}>
                    <TextField label="Email"
                               fullWidth
                               name="email"
                               value={formik.values.email}
                               onChange={formik.handleChange}
                               error={formik.touched.email && Boolean(formik.errors.email)}
                               helperText={formik.touched.email && formik.errors.email}/>
                </Grid>

                <Grid item xs={12}>
                    <Autocomplete
                        options={GeoService.COUNTRIES}
                        filterOptions={filterOptions}
                        autoHighlight
                        getOptionLabel={(option) => option.label}
                        value={GeoService.COUNTRIES.find(c => c.code === formik.values.nationality) || null}
                        onChange={(event, value) => {
                            formik.setFieldValue("nationality", value ? value.code : null)
                        }}
                        renderOption={(props, option) => (
                            <Box component="li"
                                 sx={{fontSize: 15, '& > img': {mr: 1}}}
                                 {...props}>
                                <CountryFlag code={option.code}/>
                                {option.label}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Nazionalità"
                                inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                }}
                                fullWidth
                                error={formik.touched.nationality && Boolean(formik.errors.nationality)}
                                helperText={formik.touched.nationality && formik.errors.nationality}/>
                        )}/>
                </Grid>
            </Grid>

            <Typography variant='h6' color='primary' fontWeight="normal" sx={{my: 2}}>
                Notifica check in online
            </Typography>

            {
                formik.values.email &&
                <Alert severity="success" sx={{mt: 2}}>
                    <AlertTitle>ATTIVA</AlertTitle>
                    Livignoitaly invierà all'ospite un’email per chiedere di compilare il modulo di check in.
                    L'utente portrà inserire autonomamente l'anagrafica di tutti gli ospiti ed un documento
                    di riconoscimento prima del suo arrivo in struttura.
                </Alert>
            }

            {
                !formik.values.email &&
                <Alert severity="warning" sx={{mt: 2}}>
                    <AlertTitle>NON ATTIVA</AlertTitle>
                    Per abilitare il check in online, è necessario indicare <b>l'indirizzo email</b> dell'ospite.
                </Alert>
            }
        </>
    );
};

StepGuest.propTypes = {
    formik: PropTypes.object.isRequired
};

export default StepGuest;